import {Circle, MapContainer, Marker, Popup, TileLayer, useMap, useMapEvents, MarkerCluster} from 'react-leaflet';
import React, {useState, Fragment, useRef, useContext, useEffect} from 'react';
import {Icon, divIcon} from 'leaflet';
import L from 'leaflet';
import AtualMarker from '../../../../assets/images/atualMarker.png';

// import { Container } from './styles';

function LocationMarker() {
    const [position, setPosition] = useState(null);
    const [bbox, setBbox] = useState([]);

    const map = useMap();

    useEffect(() => {
        // const map = L.map('map').setView([0, 0], 2);
        map.locate().on('locationfound', function (e) {
            setPosition(e.latlng);
            const radius = e.accuracy;

            map.eachLayer(layer => {
                if (layer instanceof L.Circle) {
                    layer.remove();
                }
            });

            const circle = L.circle(e.latlng, {
                radius: 0,
                color: '#3898f7',
                fillOpacity: 0.2,
                dashArray: '5, 5',
                weight: 1,
            });
            circle.addTo(map);

            setBbox(e.bounds.toBBoxString().split(','));
        });
    }, []);

    return position === null ? null : (
        <Marker
            position={position}
            icon={
                new divIcon({
                    html: ` <div class="flex justify-center items-center">
                        <div class="relative">
                            <img  style=" width:25px; height:25px" class="" src=${AtualMarker} />
                           
                        </div>          
                    </div>`,
                    // iconUrl: `${client.isProspect ? Prospect : Cliente}`,
                    className: `bg-red rounded-full  items-center flex`,
                    iconSize: [12, 12],
                    // iconAnchor: [20, 20],
                    // popupAnchor: [0, -20],
                    // shadowAnchor: [6, 100],
                })
            }>
            <Popup>
                You are here. <br />
                Map bbox: <br />
                <b>Southwest lng</b>: {bbox[0]} <br />
                <b>Southwest lat</b>: {bbox[1]} <br />
                <b>Northeast lng</b>: {bbox[2]} <br />
                <b>Northeast lat</b>: {bbox[3]}
            </Popup>
        </Marker>
    );
}

export default LocationMarker;
